module.exports = __webpack_public_path__ + "img/5923e81.jpg";